import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgLayout = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M16.634 1.86c.41 0 .741.331.741.74v5.13a.74.74 0 0 1-.741.74h-3.25v3.648h5.53c.372 0 .68.275.733.632l.008.11v4.387l3.248.001c.376 0 .686.279.735.64l.006.1v5.13a.74.74 0 0 1-.74.741h-7.98a.74.74 0 0 1-.74-.74v-5.13c0-.41.331-.741.74-.741h3.248V13.6H7.117v3.647l3.249.001c.375 0 .685.279.734.64l.007.1v5.13a.74.74 0 0 1-.741.741h-7.98a.74.74 0 0 1-.74-.74v-5.13c0-.41.331-.741.74-.741h3.248l.001-4.389c0-.372.274-.68.631-.733l.11-.008h5.528V8.47H8.655a.741.741 0 0 1-.734-.64l-.007-.1V2.6c0-.409.332-.74.74-.74Zm-7.01 16.87H3.126v3.648h6.498V18.73Zm12.539 0h-6.498v3.648h6.498V18.73ZM15.893 3.34H9.396V6.99h6.497V3.34Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgLayout)
const Memo = memo(ForwardRef)
export default Memo
